import useSWR from "swr";

import axios, { endpoints, fetcher } from "src/utils/axios";
import type {
  FederationRuleset,
  FederationRulesetCreate,
  FederationRulesetList,
  FederationRulesetUpdate,
  FederationRulesetVersionCreate,
} from "src/types/federation-ruleset";

export function useGetFederationRulesets(
  providerId: number,
  enabled: boolean,
  offset = 0,
) {
  const url =
    providerId > 0 && enabled
      ? [
          endpoints.provider.federation.rulesets(providerId),
          { params: { offset, limit: 20 } },
        ]
      : null;
  return useSWR<FederationRulesetList>(url, fetcher, {
    keepPreviousData: false,
  });
}

export async function createFederationRuleset(
  providerId: number,
  payload: FederationRulesetCreate,
) {
  const { data } = await axios.post<FederationRuleset>(
    endpoints.provider.federation.rulesets(providerId),
    payload,
  );
  return data;
}

export async function updateFederationRuleset(
  providerId: number,
  id: number,
  payload: FederationRulesetUpdate,
) {
  const { data } = await axios.patch<FederationRuleset>(
    endpoints.provider.federation.ruleset(providerId, id),
    payload,
  );
  return data;
}

export async function cloneFederationRuleset(
  providerId: number,
  id: number,
  payload: FederationRulesetVersionCreate,
) {
  const { data } = await axios.post<FederationRuleset>(
    `${endpoints.provider.federation.ruleset(providerId, id)}/versions`,
    payload,
  );
  return data;
}

export async function transitionFederationRuleset(
  providerId: number,
  row: FederationRuleset,
  action: "activate" | "retire",
) {
  const { data } = await axios.post<FederationRuleset>(
    `${endpoints.provider.federation.ruleset(providerId, row.id)}/${action}`,
    { expected_revision: row.revision },
  );
  return data;
}
